export function trackPixelEvent(
  eventName: string,
  params?: Record<string, any>,
) {
  if ((window as any).fbq) {
    ;(window as any).fbq('track', eventName, params)
  }
}
